import { storyActions, fleekActions } from '../actionTypes/index';

const feedAndStoryResponseTransformer = (feedComp = [], storyComp = []) => {
  let data = feedComp?.map(item => {
    if (item.type === 'STORY') {
      return {
        ...item,
        subcomponent: [...(item?.subcomponent || []), ...(storyComp?.[0]?.subcomponent || [])]
      };
    }
    return item;
  });
  return data;
};

const initialState = {
  data: {},
  loading: false,
  error: null,
  stories: { data: {}, loading: false, error: {}, expandedFetching: false }
};

const feedReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'FETCH_FEED_DATA_REQUEST':
      return {
        ...state,
        loading: true,
        error: null
      };
    case 'FETCH_FEED_DATA_SUCCESS':
      if (action.payload.feedRes?.paginationInfo?.currentPage > 0) {
        // data is already present, we will update the components array and
        // pagination info

        let storyResponse = state?.stories?.data?.layout?.components;
        const newComponents = action?.payload?.feedRes?.layout?.components;
        return {
          ...state,
          loading: false,
          data: {
            ...state.data,
            layout: {
              ...state.data?.layout,
              components: [
                ...(state.data?.layout?.components || []),
                ...(feedAndStoryResponseTransformer(newComponents, storyResponse) || [])
              ]
            },
            paginationInfo: action?.payload?.feedRes?.paginationInfo
          },
          error: null
        };
      } else {
        let feedResponse = action?.payload?.feedRes;
        let storyResponse = action?.payload?.feedStoriesRes;

        let feedComponentList = feedResponse?.layout?.components;
        let storyComponentList = storyResponse?.layout?.components;

        var finalResp = {
          ...feedResponse,
          layout: {
            ...feedResponse?.layout,
            components: feedAndStoryResponseTransformer(feedComponentList, storyComponentList)
          }
        };
        // set the data for the first time
        return {
          ...state,
          loading: false,
          data: finalResp
        };
      }

    case 'FETCH_FEED_DATA_FAILURE':
      return {
        ...state,
        loading: false,
        error: action.payload
      };

    case storyActions.SUB_STORY_SEEN:
      return {
        ...state,
        data: {
          ...state.data,
          layout: {
            ...state.data.layout,
            components: [...action.payload.newFeedComponents]
          }
        }
      };

    case fleekActions.FETCH_FEED_STORIES_DATA_FAILURE:
      return {
        ...state,
        stories: {
          ...state.stories,
          error: action.payload,
          loading: false
        }
      };

    case fleekActions.FETCH_FEED_STORIES_DATA_REQUEST:
      return {
        ...state,
        stories: {
          ...state.stories,
          loading: true,
          error: {},
          expandedFetching: action.payload.expandedFetching
        }
      };

    case fleekActions.FETCH_FEED_STORIES_DATA_SUCCESS:
      let storyResponse = action?.payload?.feedStoriesRes;
      let storyComponentList = storyResponse?.layout?.components;
      let feedComponentList = state?.data?.layout?.components;
      let currentPage = storyResponse?.paginationInfo?.currentPage;

      let updatedFeedData =
        currentPage > 0
          ? {
              ...state.data,
              layout: {
                ...state.data.layout,
                components: feedAndStoryResponseTransformer(feedComponentList, storyComponentList)
              }
            }
          : state.data;

      return {
        ...state,
        stories: {
          ...state.stories,
          loading: false,
          data: {
            ...state.stories?.data,
            ...storyResponse,
            layout: {
              ...state.stories.data?.layout,
              ...storyResponse.layout,

              components: [
                {
                  ...(state?.stories?.data?.layout?.components[0] || []),

                  subcomponent: [
                    ...(!action?.payload?.combinedData
                      ? state?.stories?.data?.layout?.components[0]?.subcomponent || []
                      : []),

                    ...(storyResponse?.layout?.components[0]?.subcomponent || [])
                  ]
                }
              ]
            }
          },
          error: {},
          expandedFetching: false
        },
        data: updatedFeedData
      };

    case storyActions.CLOSE_STORY:
      return {
        ...state,
        stories: {
          ...state.stories,
          expandedFetching: false
        }
      };

    default:
      return state;
  }
};

export default feedReducer;
